define('MachineLookUp.View', [
  'AjaxRequestsKiller',
  'Backbone',
  'MachineLookUp.Model',
  'machine_look_up.tpl',
  'jQuery',
  'underscore',
  'Utils'
], function (AjaxRequestsKiller, Backbone, MachineLookUpModel, machine_look_up_tpl, jQuery, _, Utils) {
  'use strict';

  return Backbone.View.extend({
    template: machine_look_up_tpl,

    initialize: function (options) {
      this.machineTypes = [];
      this.machineModels = [];
      this.machineCompanies = [];
      this.model = new MachineLookUpModel();
      this.application = options.application;
      this.goferModelPage = this.options.goferModelView;
      var self = this;

      this.application.getLayout().on('afterAppendView', this.getMachineCompanies, this);
      this.on('afterViewRender', function (){
        // var href = Backbone.history.location.href;
          self.showWarningMessage('Please select from all three dropdown menus');
         
         
         
      });
    },

    events: {
      'click [id="mlu-reset"]': 'resetForm',
      'click [id="mlu-find"]': 'searchItems',
      'change [name="type"]': 'getMachineModels',
      'change [name="machine"]': 'getMachineTypes'
    },

    render: function () {
      // Wrapping render with before/after fn to get and set selected after re-render
      var values = this.getFormValues();

      this._render();
      this.setFormValues(values);

      return this;
    },

    getFormValues: function () {
      return jQuery('#machine-look-up-form').serializeObject();
    },

    setFormValues: function (values) {
      _.each(values, function (v, k) {
        jQuery('[name=' + k + ']').val(v);
      });
    },

    getMachineCompanies: function (e) {
      var self = this;

      this.showLoading();
      this.model
        .fetch({
          killerId: AjaxRequestsKiller.getKillerId()
        })
        .done(function (results) {
          self.machineCompanies = _.sortBy(results.companies, 'name');

          self.hideLoading();
          self.render();
        });
    },

    getMachineTypes: function (e) {
      e.preventDefault();

      try {
        var self = this;
        var gfrCompany = e.target.value;

        this.showLoading();
        this.model
          .fetch({
            killerId: AjaxRequestsKiller.getKillerId(),
            data: {
              action: 'getTypes',
              gfrCompany: gfrCompany
            }
          })
          .done(function (res) {
            self.machineTypes = _.sortBy(res, 'name');

            self.hideLoading();
            self.render();
            self.showWarningMessage('Please select a Model type');
          });
      } catch (error) {
        console.error('MachineLookUp.View Error', error);
      }
    },

    getMachineModels: function (e) {
      e.preventDefault();

      var self = this;
      var gfrCompany = jQuery('#machine').val();
      var gfrType = e.target.value;

      this.showLoading();
      this.model
        .fetch({
          killerId: AjaxRequestsKiller.getKillerId(),
          data: {
            action: 'getModels',
            gfrCompany: gfrCompany,
            gfrType: gfrType
          }
        })
        .done(function (res) {
          self.machineModels = _.sortBy(res, 'name');

          self.hideLoading();
          self.render();
          self.showWarningMessage('Please select a Model');
        });
    },

    searchItems: function (e) {
      e.preventDefault();

      jQuery(e.currentTarget).attr('disabled', true);

      var selectedValues = this.getFormTextValues(this.getFormValues());

      Backbone.history.navigate(
        'gofer-parts/' + encodeURIComponent(selectedValues.custitem_mhi_gfr_model),
        { trigger: true }
      );
    },

    getFormTextValues: function (values) {
      var results = {
        custitem_mhi_gfr_type: '',
        custitem_mhi_gfr_model: '',
        custitem_mhi_gfr_company: ''
      };
      var selectedType = _.findWhere(this.machineTypes, { value: values.type });
      var selectedModel = _.findWhere(this.machineModels, { value: values.model });
      var selectedCompany = _.findWhere(this.machineCompanies, { value: values.machine });
      results.custitem_mhi_gfr_type = selectedType && selectedType.name;
      results.custitem_mhi_gfr_model = selectedModel && selectedModel.name;
      results.custitem_mhi_gfr_company = selectedCompany && selectedCompany.name;

      return results;
    },

    showLoading: function () {
      SC.loadingIndicatorShow();
    },

    hideLoading: function () {
      SC.loadingIndicatorHide();
    },

    resetForm: function (e) {
      e.preventDefault();

      this.machineModels = [];

      jQuery('#machine-look-up-form')[0].reset();
      Backbone.trigger('resetForm');
      this.render();
    },

    getContext: function () {
      return {
       
        machineTypes: this.machineTypes,
        machineModels: this.machineModels,
        machineCompanies: this.machineCompanies,
        isNotGoferModelPage: !this.goferModelPage,
        mluImage: !this.goferModelPage ? SC.CONFIGURATION.header.mluImage : ''
      };
    }
  });
});
